import { useState, type FormEvent } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

const navItems = [
  { label: "首页", to: "/" },
  { label: "影视", to: "/category/film" },
  { label: "音乐", to: "/category/music" },
  { label: "资讯", to: "/category/news" },
  { label: "分类", to: "/category" },
  { label: "关于", to: "/about" },
];

export default function Navbar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [keyword, setKeyword] = useState("");
  const [mobileOpen, setMobileOpen] = useState(false);

  const submitSearch = (e: FormEvent) => {
    e.preventDefault();
    const kw = keyword.trim();
    if (!kw) return;
    setMobileOpen(false);
    navigate(`/search?q=${encodeURIComponent(kw)}`);
  };

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    if (to === "/category") return location.pathname === "/category";
    return location.pathname.startsWith(to);
  };

  return (
    <header className="sticky top-0 z-40 w-full border-b border-background-200/80 bg-background-50/95 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-8">
        <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
            <i className="ri-play-circle-line text-xl" />
          </span>
          <span className="font-heading text-xl font-extrabold tracking-tight text-foreground-950">
            快猫
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`whitespace-nowrap rounded-md px-3 py-2 font-label text-sm font-medium transition-colors ${
                isActive(item.to)
                  ? "bg-primary-100 text-primary-700"
                  : "text-foreground-700 hover:bg-background-100 hover:text-foreground-950"
              }`}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <form onSubmit={submitSearch} className="hidden w-64 items-center md:flex">
          <div className="relative w-full">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
            <input
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索影视 / 音乐 / 资讯"
              className="w-full rounded-full border border-background-300/70 bg-background-100 py-2 pl-9 pr-4 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:bg-background-50"
            />
          </div>
        </form>

        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md text-foreground-800 hover:bg-background-100 md:hidden"
          aria-label="打开菜单"
        >
          <i className={mobileOpen ? "ri-close-line text-2xl" : "ri-menu-line text-2xl"} />
        </button>
      </div>

      {mobileOpen && (
        <div className="border-t border-background-200/80 bg-background-50 px-4 pb-4 pt-3 md:hidden">
          <form onSubmit={submitSearch} className="mb-3">
            <div className="relative w-full">
              <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400" />
              <input
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索影视 / 音乐 / 资讯"
                className="w-full rounded-full border border-background-300/70 bg-background-100 py-2.5 pl-9 pr-4 text-sm text-foreground-900 outline-none focus:border-primary-400"
              />
            </div>
          </form>
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <Link
                key={item.to}
                to={item.to}
                onClick={() => setMobileOpen(false)}
                className={`rounded-md px-3 py-2.5 font-label text-sm font-medium ${
                  isActive(item.to)
                    ? "bg-primary-100 text-primary-700"
                    : "text-foreground-700 hover:bg-background-100"
                }`}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}